module.exports = __webpack_public_path__ + "media/images/admin/cropping-1x1-3f423455c0a2ba3d0254c1c4e42d52cf.webp";